<template>
  <div
    :class="[
      expanded ? 'border-b border-gray-200' : '',
      headerClass
    ]"
  >
    <div
      :class="[
        'px-4 py-3',
        collapsible ? 'cursor-pointer hover:bg-gray-50 transition-colors' : '',
        $slots.bottom ? '' : ''
      ]"
      @click="collapsible && toggle()"
    >
      <div :class="['flex items-center gap-3', centered ? 'justify-center' : 'justify-between']">
        <div class="flex items-center gap-3">
          <div>
            <component :is="headingTag" :class="[headingClass, 'flex items-center gap-2']">
              <font-awesome-icon v-if="icon" :icon="icon" :class="['w-4 h-4', iconClass]" />
              {{ title }}
            </component>
            <div v-if="$slots.subtitle || subtitle" class="text-sm text-gray-500 mt-0.5 flex items-center gap-2 flex-wrap">
              <slot name="subtitle">{{ subtitle }}</slot>
            </div>
          </div>
          <slot name="actions" />
        </div>
        <div class="flex items-center gap-2">
          <slot />
          <font-awesome-icon
            v-if="collapsible"
            :icon="['fas', expanded ? 'chevron-up' : 'chevron-right']"
            class="text-gray-400 w-3 h-3"
          />
        </div>
      </div>
    </div>
    <slot name="bottom" />
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'ComponentHeader',
  components: { FontAwesomeIcon },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: null
    },
    icon: {
      type: Array,
      default: null
    },
    iconClass: {
      type: String,
      default: ''
    },
    headingLevel: {
      type: Number,
      default: 2,
      validator: (v) => [1, 2, 3, 4].includes(v)
    },
    headerClass: {
      type: String,
      default: ''
    },
    centered: {
      type: Boolean,
      default: false
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:expanded'],
  computed: {
    headingTag() {
      return `h${this.headingLevel}`;
    },
    headingClass() {
      const sizes = { 1: 'text-xl', 2: 'text-lg', 3: 'text-base', 4: 'text-sm' };
      return `${sizes[this.headingLevel]} font-semibold text-gray-800`;
    }
  },
  methods: {
    toggle() {
      this.$emit('update:expanded', !this.expanded);
    }
  }
};
</script>
